<div class="basin-p-x-1 basin-pt-1 basin-pb-2" *ngIf="studyArea">
  <div class="basin-display-flex basin-flex-row basin-justify-content-space-between basin-align-items-center basin-width-100" *ngIf="!studyArea.global">
    <span class="basin-body-small">
      {{studyArea.creationTimestamp | date : "mediumDate"}}
    </span>
  </div>

  <div class="basin-display-flex basin-flex-row basin-justify-content-space-between basin-align-items-center basin-width-100">
    <span class="basin-body-small"
      >{{ studyArea.areaMeasurement | number : "1.0-1" }}
      {{ studyArea.areaUnit }}</span
    >
  </div>
</div>
